import React from "react";
import { Container, Row } from "react-bootstrap";
import { aboutInfos } from "../Data";
import AboutDetail from "./AboutDetail";
import "../Style/AboutUs.scss";

const AboutUs = () => {
  return (
    <div className="aboutus_wrapper">
     
      <div className="section_title">
        <h4>
          ABOUT US<span>:</span>
        </h4>
      </div>
      <Container>
        <Row>
          {aboutInfos.map((info) => (
            <AboutDetail info={info} key={info.id} />
          ))}
        </Row>
       </Container>
    </div>
  );
};

export default AboutUs;
